module.exports = __webpack_public_path__ + "static/media/no_data.ad17058e.svg";